import axios from "@/lib/axios";
import { API_ADMIN } from "../../utils/constants";
import { SearchParams } from "../../utils/helpers";

const csrf = () => axios.get("/sanctum/csrf-cookie");

export async function getCourses({
    filter,
    sortBy,
    include,
    includeFields,
    searchValue,
    page = 1,
    perPage = 10,
    filterAndSortAndPageQuery,
} = {}) {
    await csrf();

    // Base API Query
    let query = `${API_ADMIN}/courses`;

    if (filterAndSortAndPageQuery) query += filterAndSortAndPageQuery;

    //Search
    if (searchValue) {
        let searchQuery = `search=${searchValue}`;
        query += `${query.includes("?") ? "&" : "?"}${searchQuery}`;
    }

    //Filter
    if (Array.isArray(filter)) {
        let filterQuery = "";

        filter.forEach((el, index) => {
            filterQuery += `${index !== 0 ? "&" : ""}filter[${el.field}]=${el.value
                }`;
        });

        query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
    } else if (filter) {
        // Check if filter is a single object
        let filterQuery = `filter[${filter.field}]=${filter.value}`;

        query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
    }

    // Sorting
    if (Array.isArray(sortBy)) {
        let sortQuery = "";

        sortBy.forEach((el, index) => {
            const direction =
                el.direction === "ascending"
                    ? ""
                    : el.direction === "descending"
                        ? "-"
                        : "";
            sortQuery += `${index !== 0 ? "," : ""}${direction}${el.field}`;
        });

        query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
    } else if (sortBy) {
        let sortQuery = `${sortBy.direction === "asc" ? "" : "-"}${sortBy.field
            }`;

        query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
    }

    // Include
    if (Array.isArray(include)) {
        let includeQuery = "";

        include.forEach((el, index) => {
            includeQuery += `${index !== 0 ? "&" : ""}include${el.field}=${el.value
                }`;
        });

        query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
    } else if (include) {
        let includeQuery = `include${include.field}=${include.value}`;

        query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
    }

    //includeFields
    if (Array.isArray(includeFields)) {
        let includeQuery = "include=";

        includeFields.forEach((el, index) => {
            includeQuery += `${index !== 0 ? "," : ""}${el}`;
        });

        query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
    } else if (includeFields) {
        let includeQuery = `include=${includeFields}`;

        query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
    }

    //Pagination
    if (page !== 0 && page >= 1) {
        query += `${query.includes("?") ? "&" : "?"}page=${page}${perPage ? "&perPage=" : ""
            }${perPage}`;
    }

    //Feaching The Data before adding all operations
    const response = await axios.get(query);

    if (response.status !== 200) {
        throw new Error(response.response.data.message);
    }

    return response.data;
}

//Create new course
export async function createCourse({ name, brief, grade, school_level, visibility, type }) {
    await csrf();
    const response = await axios.post(`${API_ADMIN}/courses`, {
        name,
        brief,
        school_level,
        grade,
        visibility,
        type,
    });

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error(response.response.data.message);
    }
}

// edit course
export async function updateCourse({
    name,
    brief,
    grade,
    school_level,
    visibility,
    type,
    courseId,
}) {
    await csrf();

    const response = await axios.put(`${API_ADMIN}/courses/${courseId}`, {
        name,
        brief,
        grade,
        school_level,
        visibility,
        type,
    });

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error(response.response.data.message);
    }
}

//Delete Course
export async function deleteCourse(courseId) {
    await csrf();

    const response = await axios.delete(`${API_ADMIN}/courses/${courseId}`);
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        throw new Error(response.response.data.message);
    }
}


//GetSchoolLevel
export async function getSchoolLevels({ filterObject }) {
    await csrf();
    let searchParams = SearchParams({ paramsObject: filterObject })
    let query = `grade-vouchers/${searchParams}`
    const response = await axios.get(`${API_ADMIN}/${query}`);

    if (response.status !== 200) {
        throw new Error(response.response.data.message);
    }
    return response.data;

}